/**
 * Insights index: AJAX category filter + pagination (no full page reload).
 */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-blog-index]');
  if (!root) return;

  var results = root.querySelector('[data-blog-results]');
  var filterNav = root.querySelector('[data-blog-filter]');
  var restUrl = root.getAttribute('data-rest-url');
  var homeUrl = root.getAttribute('data-home-url') || '/insights/';
  if (!results || !filterNav || !restUrl) return;

  var state = {
    category: '',
    page: 1,
    loading: false,
  };

  var params = new URLSearchParams(window.location.search);
  if (params.has('category')) state.category = params.get('category') || '';
  if (params.has('pg')) state.page = Math.max(1, parseInt(params.get('pg'), 10) || 1);

  function setActiveFilter(category) {
    filterNav.querySelectorAll('.blog-filter__link').forEach(function (btn) {
      var active = (btn.getAttribute('data-category') || '') === category;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateUrl() {
    var url = new URL(homeUrl, window.location.origin);
    if (state.category) url.searchParams.set('category', state.category);
    if (state.page > 1) url.searchParams.set('pg', String(state.page));
    window.history.pushState({ category: state.category, page: state.page }, '', url.pathname + url.search);
  }

  function fetchResults(push) {
    if (state.loading) return;
    state.loading = true;
    results.classList.add('is-loading');

    var url = new URL(restUrl, window.location.origin);
    if (state.category) url.searchParams.set('category', state.category);
    url.searchParams.set('page', String(state.page));

    fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed');
        return res.json();
      })
      .then(function (data) {
        results.innerHTML = data.html || '';
        setActiveFilter(state.category);
        if (push) updateUrl();
      })
      .catch(function () {
        results.innerHTML = '<p class="blog-index__empty">Unable to load posts. Please try again.</p>';
      })
      .finally(function () {
        state.loading = false;
        results.classList.remove('is-loading');
      });
  }

  filterNav.addEventListener('click', function (e) {
    var btn = e.target.closest('.blog-filter__link');
    if (!btn || !filterNav.contains(btn)) return;
    e.preventDefault();
    var category = btn.getAttribute('data-category') || '';
    if (category === state.category && !results.classList.contains('is-loading')) {
      // already active — still allow re-fetch only if needed
    }
    state.category = category;
    state.page = 1;
    fetchResults(true);
  });

  results.addEventListener('click', function (e) {
    var link = e.target.closest('[data-blog-page]');
    if (!link || !results.contains(link)) return;
    e.preventDefault();
    var page = parseInt(link.getAttribute('data-blog-page'), 10);
    if (!page || page === state.page) return;
    state.page = page;
    fetchResults(true);
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && typeof e.state.category !== 'undefined') {
      state.category = e.state.category || '';
      state.page = e.state.page || 1;
    } else {
      var p = new URLSearchParams(window.location.search);
      state.category = p.get('category') || '';
      state.page = Math.max(1, parseInt(p.get('pg'), 10) || 1);
    }
    fetchResults(false);
  });
});
